(ns quuppa.qsm.release-notes.events
  (:require [re-frame.core :refer [reg-event-fx reg-event-db]]
            [clojure.string :as str]
            [ajax.core :as ajax]
            [day8.re-frame.http-fx])
  (:require-macros [quuppa.common.version :as version]))

;; Fetch release notes from control center
(reg-event-fx
  ::fetch
  (fn [{:keys [db]} [_ {:keys [release-note-hash]}]]
    (let [app-version (-> (version/get-version-info) :app :version)
          encoded-version (js/encodeURIComponent app-version)
          fetch-uri (str "/api/release-notes/"
                         encoded-version
                         (when-not (str/blank? release-note-hash)
                           (str "/" (js/encodeURIComponent release-note-hash))))]
      {:db         (assoc-in db [:release-notes :loading?] true)
       :http-xhrio {:method          :get
                    :uri             fetch-uri
                    :on-success      [::fetched]
                    :on-failure      [::fetch-failed]
                    :response-format (ajax/json-response-format {:keywords? true})}})))

;; Store fetched release notes in app-db
(reg-event-fx
  ::fetched
  (fn [{:keys [db]} [_ response]]
    (let [app-version (-> (version/get-version-info) :app :version)
          release-note-hash (-> response :hash)
          content (-> response :content)]
      {:db       (update-in db [:release-notes] merge {:version    (-> response :version)
                                                       :hash       release-note-hash
                                                       :content    content
                                                       :loading?   false})
       :dispatch [::mark-as-seen app-version release-note-hash]})))

;; Auto-load release-notes preview content once, right after sign-in, if the
;; user's app version has changed and release notes are available for it.
;; Runs once per session as part of the sign-in flow (dispatched from
;; :user/set-user) instead of a component-lifecycle effect, since it only
;; needs to happen once when we first learn the user + availability state.
(reg-event-fx
  ::auto-check-on-signin
  (fn [{:keys [db]} [_]]
    (let [user (get-in db [:session :user])
          app-version (-> (version/get-version-info) :app :version)
          release-notes-available? (get-in db [:release-notes :available?])
          version-changed? (not= app-version (:last-seen-qsm-version user))]
      (when (and release-notes-available? version-changed?)
        {:dispatch [::fetch {:release-note-hash (:last-seen-releasenote-hash user)}]}))))

;; Open the full release-notes modal (content is already loaded by ::fetch)
(reg-event-db
  ::open-modal
  (fn [db [_]]
    (assoc-in db [:release-notes :show-modal] true)))

;; Mark release notes as seen (update backend)
(reg-event-fx
  ::mark-as-seen
  (fn [_ [_ version release-note-hash]]
    {:http-xhrio
     {:method          :post
      :uri             "/api/user/update-release-notes-last-seen"
      :params          {:qsm-version version
                        :releasenote-hash release-note-hash}
      :on-success      [::marked-as-seen]
      :on-failure      [::mark-as-seen-failed]
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})}}))

;; Update user session after marking as seen
(reg-event-db
  ::marked-as-seen
  (fn [db [_ _response]]
    (update-in db [:session :user] assoc
               :last-seen-qsm-version (-> (version/get-version-info) :app :version)
               :last-seen-releasenote-hash (get-in db [:release-notes :hash]))))

;; Handle fetch failures
(reg-event-db
  ::fetch-failed
  (fn [db [_ error]]
    (js/console.warn "Failed to fetch release notes:" error)
    (update-in db [:release-notes] merge {:loading? false :error error})))

;; Handle mark-as-seen failures
(reg-event-db
  ::mark-as-seen-failed
  (fn [db [_ error]]
    (js/console.warn "Failed to mark release notes as seen:" error)
    db))

;; Close release notes modal
(reg-event-db
  ::close-modal
  (fn [db [_]]
    (assoc-in db [:release-notes :show-modal] false)))

